import * as CommonType from "../../action/actiontype/CommonType/CommonType.jsx";

const commonReducer = (state = {}, action) => {
    switch (action.type) {
        
        case CommonType.SIDEBARVIEW:
            return{
                ...state,
                isSidebarView:action.payload

            }
        case CommonType.LOGINDATA:
            return{
                ...state,
                loginData:action.payload
            }
        case CommonType.RESETPWDDATA:
            return{
                 ...state,
            resetPwd:action.payload
         }
            // translation
        case CommonType.TRANSLATE_REQUEST:
                return {
                    ...state,
                    translateLoading: true,
                    translateResponse:[],
                    translateError: null
                } 
        case CommonType.TRANSLATE_SUCCESS:
                return {
                    ...state,
                    translateLoading: false,
                    translateResponse: action.payload,
                    // adminPPResponse: [],
                    translateError: null
                }
        case CommonType.TRANSLATE_FAILURE:
                return {
                    ...state,
                    translateLoading: false,
                    translateError: action.payload,
                    translateResponse:[],
                }
        case CommonType.PATIENTGETIDCOMMON:
                return{
                    ...state,
            getPatientData:action.payload
        
         }
        // get Authentication Type
        case CommonType.AUTHENTICATION_TYPE_REQUEST:
            return {
                ...state,
                getAuthenticationTypeLoading: true,
                getAuthenticationTypeResponse: {},
                getAuthenticationTypeError: null
            } 
        case CommonType.AUTHENTICATION_TYPE_SUCCESS:
            return {
                ...state,
                getAuthenticationTypeLoading: false,
                getAuthenticationTypeResponse: action.payload,
                getAuthenticationTypeError: null
            }
        case CommonType.AUTHENTICATION_TYPE_FAILURE:
            return {
                ...state,
                getAuthenticationTypeLoading: false,
                getAuthenticationTypeError: action.payload,
                getAuthenticationTypeResponse: {}
            }


        //  case CommonType.ROLEID:
        //     return {
        //         ...state,
        //         roleIdLoading: false,
        //         roleIdError: action.payload,
        //         roleIdResponse:[],
        //     }
        default:
            return state;
    }
}

export default commonReducer;